import { PublicAlreadyDeny } from '@/assets/icons/intros';
import Logo from '@/icons/Logo';
import { useAcceptPublicIntroMutation } from '@/store/query/public-intros';
import { Box, Button, Flex, Icon, Spinner, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { HiCheckCircle } from 'react-icons/hi';
import { getMessage } from './constant';

export const AccepetedIntro = ({ intro }) => {
  return (
    <Flex
      w="100%"
      h="100vh"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      className="public-results-bg"
    >
      <Icon as={HiCheckCircle} w="55px" h="55px" color="#24A148" />
      <Text fontSize="26px" fontWeight="semiBold" mb="12px" mt="20px">
        Thanks for agreeing for an introduction.
      </Text>
      <Text mb="36px">
        The recruiter ({intro?.requester?.name}) will be in touch with you as
        soon as possible.
      </Text>
      <Box textAlign="center" pos="absolute" bottom="30px">
        <Icon as={Logo} width="32px" height="32px" borderRadius="12px" />
        <Text fontWeight="semiBold" mt="12px">
          Powered by kula
        </Text>
      </Box>
    </Flex>
  );
};

export const IntroTextResult = ({
  text = '',
  isIconPresent = false,
  icon = <></>,
}) => {
  return (
    <Flex
      w="100%"
      h="100vh"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      className="public-results-bg"
    >
      {isIconPresent && icon}
      <Text fontSize="26px" fontWeight="semiBold" mb="12px">
        {text}
      </Text>

      <Box textAlign="center" pos="absolute" bottom="30px">
        <Icon as={Logo} width="32px" height="32px" borderRadius="12px" />
        <Text fontWeight="semiBold" mt="12px">
          Powered by kula
        </Text>
      </Box>
    </Flex>
  );
};

export const DeclinedIntro = ({ intro = {}, introId = '' }) => {
  const [loading, setloading] = useState(false);
  const [introState, setIntroState] = useState(null);
  const [acceptPublicIntro] = useAcceptPublicIntroMutation();

  const onAccept = async () => {
    setloading(true);
    const res = await acceptPublicIntro({ introId: introId });
    if (res?.error?.length) {
      setIntroState(res?.error[0]);
      setloading(false);
      return;
    }
    setIntroState('declined_accept');
    setloading(false);
  };

  if (loading) {
    return (
      <Flex h="100vh" justifyContent="center" alignItems="center">
        <Spinner color="#0043CE" />
      </Flex>
    );
  }

  if (introState === 'declined_accept') {
    return <AccepetedIntro intro={intro} />;
  }

  if (introState) {
    return <IntroTextResult text={getMessage(introState)} />;
  }
  return (
    <Flex
      w="100%"
      h="100vh"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      className="public-results-bg"
    >
      <Icon as={PublicAlreadyDeny} width="160px" height="120px" mb="20px" />
      <Text fontSize="26px" fontWeight="semiBold" mb="12px">
        You have already declined the intro!
      </Text>
      <Text mb="36px" w="500px" textAlign="center">
        Have you changed your mind and want to be introed now? Note that the
        position might not be available anymore.
      </Text>
      <Button mb="30px" onClick={onAccept} data-test-id="denied-accept-button">
        Yes, I’m interested to learn more
      </Button>
      <Box textAlign="center" pos="absolute" bottom="30px">
        <Icon as={Logo} width="32px" height="32px" borderRadius="12px" />
        <Text fontWeight="semiBold" mt="12px">
          Powered by kula
        </Text>
      </Box>
    </Flex>
  );
};
